import { render, staticRenderFns } from "./VehicleStats.vue?vue&type=template&id=f05bfa98"
import script from "./VehicleStats.vue?vue&type=script&lang=js"
export * from "./VehicleStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports